module.exports = __webpack_public_path__ + "img/radtourenplaner_hessen.d9ed1808.png";